import { Injectable } from '@angular/core';
import {IMqttMessage, IMqttServiceOptions, MqttService} from "ngx-mqtt";
import {versions} from "../../environments/version";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class ConfigMqttService {

  private mqttService: MqttService | undefined;
  private isConnected: boolean = false;
  private rev = versions.revision;
  /*private connection: IMqttServiceOptions = {
    hostname: 'mqtt.conecta.qa.cursor.cl',
    port: 8083,
    // path: '',
    // clean: true, // Retain session
    //vconnectTimeout: 4000, // Timeout period
    //vreconnectPeriod: 4000, // Reconnect period
    // Authentication information
    // clientId: `mqtt--rev${this.rev}`,
    username: 'user_read',
    password: 'QA_RD_as1273rtahjF',
    protocol: 'wss',
  }*/

  private connection: IMqttServiceOptions = {
    hostname: 'live.hualpen.cursor.cl',
    port: 8083,
    path: '',
    //reconnectPeriod: 4000
    //connectTimeout: 4000
    //vconnectTimeout: 4000, // Timeout period
    //vreconnectPeriod: 4000, // Reconnect period
    // Authentication information
    clientId: `conecta--rev${this.rev}--${Math.random().toString(36).substring(2, 15)}`,
    username: 'hualpen_com_prod',
    password: 'COMPROD_djhgd63bsuGFfd53gfahs2D',
    protocol: 'wss',
  }

  constructor(private _mqttService: MqttService) {
    this.createConnection();
  }

  createConnection() {
    try {
      this._mqttService?.connect(this.connection);
    } catch (error) {
      console.log('error conexion mqtt', error)
    }

    this._mqttService?.onConnect.subscribe((resp) => {
      this.isConnected = true;
      console.log('exito conexion mqtt');
    });

    this._mqttService?.onError.subscribe((error: any) => {
      this.isConnected = false
      console.log('Error mqtt', error);
    })

    this._mqttService?.onMessage.subscribe((packet: any) => {
      //this.receiveNews = this.receiveNews.concat(packet.payload.toString())
      //console.log(`Received message ${packet.payload.toString()} from topic ${packet.topic}`);
    })
  }

  getTopicRootByEnvironment(): string {
    if(environment.envName == 'qa' || environment.envName == 'dev')
      return 'q';
    else if(environment.envName == 'prod')
      return 'p';
    else
      return 'q';
  }

  subscribeTopicJornada(uuidJornada: string): Observable<IMqttMessage> {
    return this._mqttService.observe(this.getTopicRootByEnvironment() + `/sj/${uuidJornada}`, { qos: 0 });
  }

  subscribeTopicConductor(uuidConductor: string): Observable<IMqttMessage> {
    return this._mqttService.observe(this.getTopicRootByEnvironment() + `/sc/${uuidConductor}`, { qos: 0 });
  }

  subscribeTopicMovil(numeroInterno: string): Observable<IMqttMessage> {
    return this._mqttService.observe(this.getTopicRootByEnvironment() + `/sm/${numeroInterno}`, { qos: 0 });
  }

  subscribeTopicViajes(uuidViaje: string): Observable<IMqttMessage> {
    return this._mqttService.observe(this.getTopicRootByEnvironment() + `/sv/${uuidViaje}`, { qos: 0 });
  }

  subscribeTopicComodin(): Observable<IMqttMessage> {
    return this._mqttService.observe(this.getTopicRootByEnvironment() + '/sm/#', { qos: 0 });
  }


  destroyConnection() {
    try {
      this._mqttService?.disconnect(true);
      this.isConnected = false;
      console.log('exito mqtt disconnected!');
    } catch (error: any) {
      console.log('error mqtt disconnected', error);
    }
  }


}
